import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
} from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

interface ActorRenameResponse {
  is_duplicate: boolean,
}

class ActorRenameData {
  @Required("isDuplicate cannot be empty")
  @IsBoolean("isDuplicate must be a boolean")
  isDuplicate: boolean;
}

const transformAndValidateData = (
  response: ActorRenameResponse
): ActorRenameData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ActorRenameData);
  } catch (error) {
    console.error("checkAudioNameDuplicate data validation failed:", error.message);
    throw error;
  }
};

/** 演员重名校验 */
export const checkActorNameDuplicate = async ({ name, userId }: { name: string; userId?: string }) => {
  const res = await apiV2.post<ActorRenameResponse>('/users/check-actor-name-duplicate', {
    input_name: name,
    user_id: userId,
  });
  const data = transformAndValidateData(res.data);
  return data;
}